import { Blue, White, Sky, Pink, Blood, GrayLight, Black, GrayDark, Grass, Cream, Gold, Mint } from './colors';
export var ButtonAlignment;
(function (ButtonAlignment) {
    ButtonAlignment["Left"] = "left";
    ButtonAlignment["Right"] = "right";
    ButtonAlignment["Center"] = "center";
})(ButtonAlignment || (ButtonAlignment = {}));
export const alignmentSet = {
    [ButtonAlignment.Left]: 'flex-start',
    [ButtonAlignment.Right]: 'flex-end',
    [ButtonAlignment.Center]: 'center',
};
export var ButtonStyleTypes;
(function (ButtonStyleTypes) {
    ButtonStyleTypes["ActiveA"] = "activeA";
    ButtonStyleTypes["ActiveB"] = "activeB";
    ButtonStyleTypes["ActiveC"] = "activeC";
    ButtonStyleTypes["SuccessA"] = "successA";
    ButtonStyleTypes["NeutralA"] = "neutralA";
    ButtonStyleTypes["NeutralB"] = "neutralB";
    ButtonStyleTypes["NeutralC"] = "neutralC";
    ButtonStyleTypes["WarnA"] = "warnA";
    ButtonStyleTypes["WarnB"] = "warnB";
    /**
     * @deprecated Use single "disabled" prop instead.
     */
    ButtonStyleTypes["Disabled"] = "disabled";
    ButtonStyleTypes["Default"] = "default";
})(ButtonStyleTypes || (ButtonStyleTypes = {}));
export const stylesSet = {
    activeA: {
        background: Blue,
        color: White,
    },
    activeB: {
        background: Sky,
        color: Blue,
    },
    activeC: {
        background: White,
        color: Blue,
    },
    successA: {
        background: Grass,
        color: White,
    },
    neutralA: {
        background: GrayDark,
        backdropFilter: 'blur(25px)',
        color: White,
    },
    neutralB: {
        background: White,
        color: Black,
    },
    neutralC: {
        background: 'rgba(0,0,0,0.6)',
        color: White,
    },
    warnA: {
        background: Blood,
        color: White,
    },
    warnB: {
        background: Pink,
        color: Blood,
    },
    disabled: {
        background: GrayLight,
        color: GrayDark,
    },
    default: {
        background: 'initial',
        color: 'initial',
    },
};
// STATES
export var ButtonStateTypes;
(function (ButtonStateTypes) {
    ButtonStateTypes["Disabled"] = "disabled";
    ButtonStateTypes["Pending"] = "pending";
    ButtonStateTypes["Done"] = "done";
})(ButtonStateTypes || (ButtonStateTypes = {}));
export const stateStylesSet = {
    disabled: {
        background: GrayLight,
        color: GrayDark,
        cursor: 'initial',
    },
    pending: {
        background: Cream,
        color: Gold,
        cursor: 'initial',
    },
    done: {
        background: Mint,
        color: Grass,
        cursor: 'initial',
    },
};
//# sourceMappingURL=button.js.map